<template>
  <div class="tracklist-block">
    <table>

      <thead>
        <tr>
          <th></th>
          <th>titolo</th>
          <th>genere</th>
        </tr>
      </thead>

      <tbody>		  
        <tr 
          v-for="(song, index) in songs" 
          :key="song.id" 
          @click.prevent="updateActiveSong(index + 1)" 
          :class="{current: (activeIndex - 1) == index, highlight: highlightedIndexes.includes(index)}"
        >
          <td>{{index + 1}}</td>
          <td>
            <span class="title-line">{{song.title}}</span>
            <span class="caption-line arial small">{{song.caption}}</span>
          </td>
          <td>{{song.genre && song.genre.name}}</td>
        </tr>
      </tbody>
      
    </table>
  </div>
</template>

<script>
export default {
  props: ['songs', 'activeIndex', 'highlightedIndexes'],

  methods: {
    updateActiveSong: function(i) {
      this.$emit('song:update', i);
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/vue/components/AlbumTracklist.vue